module.exports = __webpack_public_path__ + "static/jfa-c0bba9d761d23b40765439bb475e7704.png";